<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<style>
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s;
}
.slide-fade-enter-from {
    opacity: 0;
    transform: translate(50px, 0);
}
.slide-fade-leave-to {
    opacity: 0;
    transform: translate(-50px, 0);
}
</style>

<script setup>
useHead({
    title: 'Helikoptervlucht',
    htmlAttrs: {
        'data-bs-theme': 'light',
    },
})
</script>
